/* eslint-disable eqeqeq */
import React, { useState, useEffect } from "react";
import { httpPost, httpPut } from "../../utility/requestHelper";
import { Modal } from "react-bootstrap";
import { formatDate } from "../../utility/common-methods";
import { unifiedEnvConfig } from "../../constants/api-endpoint";
import { useSelector } from "react-redux";
import { ModalCloseIcon } from "../Icons/icons.component";
import {
  VERTICAL_OPTIONS,
  GRAPH_TYPE_OPTIONS,
  HTTP_CODES,
  CONSTANTS,
  DATE_FORMATS,
  GRANULARITY_OPTIONS,
  SOCIAL_SOURCES_OPTIONS,
  VERTICALS,
  REPORT_TYPES,
  FILTER_NAMES,
  GRAPH_TYPES,
} from "../../constants/app-constant";
import {
  WIDGET_TYPE_OPTIONS,
  WIDGET_TYPES,
  DATA_TYPES_OPTIONS,
  DATA_TYPES,
} from "../../constants/static-filter";
import { useParams } from "react-router-dom";
import { FilterItem } from "../NewsAndAnalysis/Filters/FilterItem";
import { AddWidgetIcon } from "../Icons/icons.component";
import Loader from "rsuite/Loader";
import { CustomBSDropdown } from "../Shared";

const { CREATED, SUCCESS } = HTTP_CODES;
const {
  EMPTY_STRING,
  EMPTY_ARRAY,
  REPORTS: { TYPES },
} = CONSTANTS;
const { MMDDYYYY_slash } = DATE_FORMATS;

export const AddWidget = function ({
  setWidgetCreationStatus,
  editWidgetData,
  handleTodayFeedWidgeStatus,
  showTodaysFeedWidget,
  fetchWidgets,
  setEditWidgetData,
  showButton,
  hideModal,
  showModal,
}) {
  const { dashboard_id } = useParams();
  const [selectedReport, setSelectedReport] = useState(EMPTY_STRING);
  const [selectedVertical, setSelectedVertical] = useState(EMPTY_STRING);
  const [graphType, setGraphType] = useState(EMPTY_STRING);
  const [gTypeOptions, setGTypeOptions] = useState(EMPTY_ARRAY);
  const [granularity, setGranularity] = useState(GRANULARITY_OPTIONS[0].value);
  const [source, setSource] = useState(EMPTY_STRING);
  const [errorMessage, seterrorMessage] = useState(false);
  const [widgetType, setWidgetType] = useState(null);
  const [filters, setFilters] = useState({
    entity: [],
  });
  const [selectedfilter, setSelectedFilter] = useState(undefined);
  const [apiInProgress, setApiInProgress] = useState(false);
  const [showAddWidgetPopup, setShowAddWidgetPopup] = useState(false);
  const [selectAll, setSelectAll] = useState(true);
  const [valueType, setValueType] = useState(DATA_TYPES.N_TEXT);
  const selectedClient =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.selectedClient
    ) || {};

  // useEffect(() => {
  //   const selectedReportType = TYPES.filter(
  //     (e) => e.type === "quantitive"
  //   ).find(({ value }) => value == selectedReport.value);
  //   setGTypeOptions(
  //     GRAPH_TYPE_OPTIONS.filter(
  //       (opt) =>
  //         selectedReportType &&
  //         selectedReportType.excludeGraphType.indexOf(opt.value) === -1
  //     )
  //   );
  // }, [selectedReport, editWidgetData]);
   useEffect(() => {
    const selectedReportType = TYPES.filter(
      (e) => e.type === "quantitive"
    ).find(({ value }) => value == selectedReport.value);
    setGTypeOptions(
      GRAPH_TYPE_OPTIONS.filter(
        (opt) =>
          selectedReportType &&
          selectedReportType.excludeGraphType.indexOf(opt.value) === -1
      )
    );
  }, [selectedReport, editWidgetData]);

  const filterState = useSelector((state) => state.filterReducer);
  const {
    entityFilter = [],
    socialEntityFilter = [],
    reportsEntityFilter = [],
  } = filterState;

  const hasEntityFilter =
    reportsEntityFilter &&
    reportsEntityFilter.values &&
    reportsEntityFilter.values.length;

  useEffect(() => {
    initEntityFilter();
  }, [entityFilter, socialEntityFilter]);

  useEffect(() => {
    if (editWidgetData) {
      const {
        topic_ids,
        report_type,
        type,
        graph_type,
        channel_type,
        date_granularity,
        value_type,
      } = editWidgetData;
      setShowAddWidgetPopup(true);
      setFilters({ entity: topic_ids && topic_ids.map(String) });
      const v = VERTICAL_OPTIONS.find((vOp) => vOp.value == type);
      setSelectedReport(
        TYPES.filter((e) => e.type === "quantitive").find(
          (elm) => elm.value == report_type
        )
      );
      setGraphType(GRAPH_TYPE_OPTIONS.find((elm) => elm.value == graph_type));
      setSource(
        SOCIAL_SOURCES_OPTIONS.find((elm) => elm.value == channel_type)
      );
      setGranularity(
        GRANULARITY_OPTIONS.find((elm) => elm.value == date_granularity)
      );
      setValueType(value_type);
      setSelectedVertical(v);
    }
  }, [editWidgetData]);

  useEffect(() => {
    if (!editWidgetData) {
      setSelectedReport(EMPTY_STRING);
      setGraphType(EMPTY_STRING);
      setGranularity(GRANULARITY_OPTIONS[0].value);
    }
    setSource(null);
  }, [selectedVertical]);

  useEffect(() => {
    if (!hideModal) {
      setShowAddWidgetPopup(false);
    }
    if (showModal) {
      setShowAddWidgetPopup(showModal);
    }
  }, [hideModal, showModal]);

  const clientId = selectedClient && selectedClient.id;
  const reportTypeOptions = TYPES.filter((e) => e.type === "quantitive" && ((e.allowed_client && e.allowed_client?.includes(Number(clientId))) || e.allowed_client == undefined) ).filter(
    (rType) => {
      if (!selectedVertical) {
        return false;
      }
      const reportVerticals = rType.verticalList || [];
      return reportVerticals.indexOf(selectedVertical.value) !== -1;
    }
  );

  const isSocial =
    selectedVertical && selectedVertical.value == VERTICALS.V_SOCIAL;
  const showAdvance = selectedReport.value == REPORT_TYPES.SOV_NOA_TREND;

  const disableSubmit = () => {
    const allowedGraphTypes =
      gTypeOptions && gTypeOptions.map((e) => e && e.value);
    if (widgetType === WIDGET_TYPES.FEED_WIDGET) {
      return false;
    }
    if (
      graphType &&
      editWidgetData &&
      allowedGraphTypes.indexOf(graphType.value) == -1
    ) {
      return true;
    }
    return !selectedVertical || !selectedReport || !graphType || apiInProgress;
  };

  const initEntityFilter = () => {
    if (!selectAll) {
      setFilters({ entity: [] });
      return;
    }
    if (
      hasEntityFilter &&
      (selectedVertical.value == VERTICALS.V_ONLINE ||
        selectedVertical.value == VERTICALS.V_PRINT)
    ) {
      setFilters({
        entity: reportsEntityFilter.values.map((e) => e && e.id.toString()),
      });
    } else {
      setFilters({
        entity:
          socialEntityFilter &&
          Array.isArray(socialEntityFilter.values) &&
          socialEntityFilter.values.map((e) => e && e.id.toString()),
      });
    }
  };

  const onCancel = () => {
    setShowAddWidgetPopup(false);
    if (setEditWidgetData) {
      setEditWidgetData(null);
    }
  };

  function createWidget() {
    if (apiInProgress) {
      return;
    }
    if (widgetType === WIDGET_TYPES.FEED_WIDGET) {
      handleTodayFeedWidgeStatus(true);
      setWidgetType("");
    }

    if (widgetType === WIDGET_TYPES.REPORT_WIDGET) {
      const selectedTopicList = filters.entity;
      const widgetData = {
        dashboard_id: dashboard_id,
        name: "",
        topic_ids: selectedTopicList,
        type: selectedVertical.value,
        report_type: selectedReport && selectedReport.value,
        from_date: formatDate(new Date(), MMDDYYYY_slash),
        to_date: formatDate(new Date(), MMDDYYYY_slash),
        graph_type: graphType && graphType.value,
        date_granularity: granularity && granularity.value,
        channel_type: (source && parseInt(source.value, 10)) || null,
        value_type: valueType,
      };
      console.log("widgets data ",widgetData)
      if (selectedTopicList.length > 0) {
        seterrorMessage(false);
        if (editWidgetData) {
          setApiInProgress(true);
          httpPut(
            `${unifiedEnvConfig.WIDGET}/${editWidgetData.id}?client_id=${clientId}`,
            widgetData
          )
            .then(({ status, message }) => {
              if (status === SUCCESS) {
                onCancel();
                setWidgetCreationStatus("Widget edited successfully");
                fetchWidgets();
              } else {
                setWidgetCreationStatus(message);
              }
            })
            .finally(() => {
              setApiInProgress(false);
            });
        } else {
          setApiInProgress(true);
          httpPost(
            `${unifiedEnvConfig.WIDGET}?client_id=${clientId}`,
            widgetData
          )
            .then((res) => {
              const {
                data: { status, message },
              } = res || {};
              if (status === CREATED) {
                onCancel();
                setWidgetCreationStatus("Widget created successfully");
                fetchWidgets();
              } else {
                alert(message);
              }
            })
            .finally(() => {
              setApiInProgress(false);
            });
        }
      } else {
        seterrorMessage(true);
      }
    }
  }

  const isSelected = (title = "", value = "") => {
    if (!value) {
      return true;
    }
    if (title === "Vertical") {
      return selectedVertical && selectedVertical.value == value;
    }
    if (title === "Report Type") {
      return selectedReport.value == value;
    }
    if (title === "Graph Type") {
      return graphType.value == value;
    }
    if (title === "Granularity") {
      return granularity == value;
    }
    if (title === "Source") {
      return source == value;
    }
  };

  const onVerticalChange = (value) => {
    handleFilterSelect(FILTER_NAMES.ENTITY, null, true, null);
    const v = VERTICAL_OPTIONS.find((vOp) => vOp.value == value);
    setSelectedVertical(v);
  };

  const renderWidgetTypeSelector = () => {
    const { FEED_WIDGET, REPORT_WIDGET } = WIDGET_TYPES;

    if (editWidgetData) {
      widgetType !== REPORT_WIDGET && setWidgetType(REPORT_WIDGET);
      return "";
    }
    const hideFeedWidgetOption = showTodaysFeedWidget;
    if (hideFeedWidgetOption && !widgetType) {
      setWidgetType(REPORT_WIDGET);
    }
    let tempOptions = WIDGET_TYPE_OPTIONS;

    return tempOptions.map((wtOpt) => {
      const disable = hideFeedWidgetOption && wtOpt.id === FEED_WIDGET;
      const isChecked = hideFeedWidgetOption
        ? !disable
        : widgetType === wtOpt.id;
      return (
        <div className="radio-inline">
          <label className="inputWrap">
            {wtOpt.name}
            <input
              onChange={(e) => setWidgetType(wtOpt.id)}
              type="radio"
              name={wtOpt.name}
              checked={isChecked}
              disabled={disable}
            />
            <span className="checkmark"></span>
          </label>
        </div>
      );
    });
  };

  const renderValueTypeSelector = () => {
    const gType = graphType && graphType.value;
    if (gType && (gType == GRAPH_TYPES.PIE || gType == GRAPH_TYPES.DOUGHNUT)) {
      return (
        <div className="form-group valueType">
          <label>Value Type</label>
          <div className="form-option">
            {DATA_TYPES_OPTIONS.map(({ text }) => {
              const isChecked = valueType == text;
              return (
                <div className="radio">
                  <label className="inputWrap">
                    {text}
                    <input
                      onChange={(e) => setValueType(text)}
                      type="radio"
                      name={text}
                      checked={isChecked}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
              );
            })}
          </div>
        </div>
      );
    }
    return null;
  };

  const getCorrectEntityList = () => {
    const { value = "" } = selectedVertical || {};
    switch (value) {
      case VERTICALS.V_SOCIAL:
        return socialEntityFilter;
      case VERTICALS.V_BLOG:
        return socialEntityFilter;
      case VERTICALS.V_FORUM:
        return socialEntityFilter;
      case VERTICALS.V_PRINT:
        return reportsEntityFilter;
      case VERTICALS.V_ONLINE:
        return reportsEntityFilter;
      case VERTICALS.V_TV:
        return reportsEntityFilter;
      default:
        return [];
    }
  };

  const renderReportWidgetConfig = () => {
    return (
      <>
        <div className="widgetFiltersWrap">
          <div className="filtersColumnWrap">
            <div className="form-group verticalOptions">
              <label>Vertical</label>
              <div className="form-option">
                <CustomDropdown
                  title="Vertical"
                  options={VERTICAL_OPTIONS}
                  onSelect={onVerticalChange}
                  isSelected={isSelected}
                  required
                  currentSelected={selectedVertical && selectedVertical.value}
                  isRadio
                />
              </div>
            </div>
            {selectedVertical && widgetType && (
              <div className="entityDropdown">
                <FilterItem
                  filters={filters}
                  setSelectedFilter={setSelectedFilter}
                  selectedFilter={selectedfilter}
                  handleFilterSelect={handleFilterSelect}
                  filterOption={getCorrectEntityList()}
                  showSelectedAll
                />
              </div>
            )}
            <div className="form-group reportType">
              <label>Report Type</label>
              <div className="form-option">
                <CustomBSDropdown
                  config={{ name: "Report Type", options: reportTypeOptions }}
                  selectedItem={selectedReport}
                  onSelect={setSelectedReport}
                  identifier=".reportType"
                />
              </div>
            </div>
            <div className="form-group graphType">
              <label>Graph Type</label>
              <div className="form-option">
                <CustomBSDropdown
                  config={{ name: "Graph Type", options: gTypeOptions }}
                  selectedItem={graphType}
                  onSelect={setGraphType}
                  identifier=".graphType"
                />
              </div>
            </div>
            {isSocial && showAdvance && (
              <div className="form-group granularity">
                <label>Granularity</label>
                <div className="form-option">
                  <CustomBSDropdown
                    config={{
                      name: "Granularity",
                      options: GRANULARITY_OPTIONS,
                    }}
                    selectedItem={granularity}
                    onSelect={setGranularity}
                    identifier=".granularity"
                  />
                </div>
              </div>
            )}
            {isSocial && (
              <div className="form-group platform">
                <label>Platform </label>
                <div className="form-option">
                  <CustomBSDropdown
                    config={{
                      name: "Platform",
                      options: SOCIAL_SOURCES_OPTIONS,
                    }}
                    selectedItem={source}
                    onSelect={setSource}
                    identifier=".platform"
                  />
                </div>
              </div>
            )}
            {renderValueTypeSelector()}
            {errorMessage ? (
              <div style={{ textAlign: "center", color: "red" }}>
                Please select at least one topic.
              </div>
            ) : null}
          </div>
        </div>
      </>
    );
  };

  const handleFilterSelect = (name, value, resetAll, selectAll) => {
    if (name == FILTER_NAMES.ENTITY) {
      if (resetAll) {
        setSelectAll(false);
        initEntityFilter();
        return;
      }
      if (selectAll) {
        setSelectAll(true);
        initEntityFilter();
        return;
      }
      const tempEntity = [...filters.entity];
      const elmIndex = tempEntity.indexOf(value.toString());
      if (elmIndex === -1) {
        tempEntity.push(value.toString());
        setFilters({ ...filters, entity: tempEntity });
      } else {
        tempEntity.splice(elmIndex, 1);
        setFilters({ ...filters, entity: tempEntity });
      }
    }
  };

  return (
    <>
      {showButton ? (
        <button
          className="btn btnBlue addWidgetBtn"
          variant="danger"
          onClick={() => setShowAddWidgetPopup(true)}
        >
          <AddWidgetIcon /> <span>Add Widget</span>
        </button>
      ) : null}
      {showAddWidgetPopup && (
        <Modal
          onHide={onCancel}
          show={showAddWidgetPopup}
          backdrop="static"
          keyboard={false}
          className="addWidgetModal"
          dialogClassName="customModal"
        >
          <Modal.Header>
            <span className="btnClose" onClick={() => onCancel(false)}>
              <ModalCloseIcon />
            </span>
          </Modal.Header>
          <Modal.Body>
            <div className="modaleHeader">
              <h2>{`${editWidgetData ? "Edit" : "Add"} Widget`}</h2>
            </div>
            <div className="widgetTypeOptions">
              {renderWidgetTypeSelector()}
            </div>
            {widgetType === WIDGET_TYPES.REPORT_WIDGET &&
              renderReportWidgetConfig()}
          </Modal.Body>
          <Modal.Footer>
            <div className="form-group form-action">
              <button
                className="btn btnBlue cancelBtn"
                onClick={() => onCancel(false)}
              >
                Cancel
              </button>
              <button
                className="btn btnBlue"
                onClick={createWidget}
                disabled={disableSubmit()}
              >
                {editWidgetData ? "Update widget" : "Add widget"}
              </button>
              {apiInProgress && <Loader />}
            </div>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};

function CustomDropdown({
  currentSelected,
  title,
  required,
  onSelect,
  options,
  isSelected,
  isRadio,
}) {
  if (isRadio) {
    function onSelectRadioOption(v) {
      onSelect(v);
    }
    return (
      <>
        {options.map((radio, idx) => (
          <div className="radio">
            <label className="inputWrap">
              {radio.label}
              <input
                key={idx}
                type="radio"
                variant="secondary"
                name="radio"
                value={radio.label}
                checked={currentSelected == radio.value}
                onChange={(e) => onSelectRadioOption(radio.value)}
              />
              <span class="checkmark"></span>
            </label>
          </div>
        ))}
      </>
    );
  }

  function onSelectOption(evt) {
    onSelect(evt.currentTarget.value);
  }
  return (
    <>
      <select onChange={onSelectOption} className="form-control">
        <option selected={isSelected(title, "")} value="">
          {title}
        </option>
        {options.map((opt) => {
          const val = opt.value;
          return (
            <option selected={isSelected(title, val)} key={val} value={val}>
              {opt.label}
            </option>
          );
        })}
      </select>
    </>
  );
}

CustomDropdown.defaultProps = {
  title: "",
  selected: "",
  onSelect: () => {},
  options: [],
};
